import { Button, Col, Divider, Form, FormInstance, Row, Select } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import moment, { Moment } from 'moment';
import { WorkOrderComplementType } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { isAppPortocar } from '@/index';

interface FormValues {
  companiesIds: number[];
  types: WorkOrderComplementType;
  initialDate: Moment;
  finalDate: Moment;
}

interface Props {
  form: FormInstance<FormValues>;
}

function InvoicingAverageTicketForm({ form }: Props) {
  const intl = useIntl();

  const [workOrderSelectOpen, setWorkOrderSelectOpen] = useState(false);

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name="initialDate"
            label={'Data Inicial'}
            initialValue={moment().subtract(5, 'months')}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="finalDate"
            label={'Data Final'}
            initialValue={moment()}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label={'Empresas'} name="companiesIds">
            <CompaniesInfiniteSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            label="Tipos de Orçamento"
            name="types"
            rules={[
              {
                required: true,
                message: 'Selecione pelo menos 1 tipo de orçamento',
              },
            ]}
            initialValue={[
              WorkOrderComplementType.Courtesy,
              WorkOrderComplementType.Warranty,
              WorkOrderComplementType.WorkOrder,
              WorkOrderComplementType.TotalLoss,
              WorkOrderComplementType.Return,
              WorkOrderComplementType.Revision,
            ]}
          >
            <Select
              style={{ width: '100%' }}
              mode="multiple"
              onDropdownVisibleChange={(open) => setWorkOrderSelectOpen(open)}
              options={[
                {
                  value: WorkOrderComplementType.Courtesy,
                  label: intl.formatMessage({
                    id: `dashboard.averageTicket.modal.form.${
                      isAppPortocar ? 'insideCourtesy' : 'courtesy'
                    }`,
                  }),
                },
                {
                  value: WorkOrderComplementType.Warranty,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.warranty',
                  }),
                },
                {
                  value: WorkOrderComplementType.WorkOrder,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.work_order',
                  }),
                },
                {
                  value: WorkOrderComplementType.TotalLoss,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.total_loss',
                  }),
                },
                {
                  value: WorkOrderComplementType.Return,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.return',
                  }),
                },
                {
                  value: WorkOrderComplementType.Revision,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.revision',
                  }),
                },
              ]}
              allowClear
              open={workOrderSelectOpen}
              dropdownRender={(item) => (
                <>
                  <Button
                    block
                    type="link"
                    onClick={() => {
                      form.setFields([
                        {
                          name: 'types',
                          value: [...Object.values(WorkOrderComplementType)],
                          errors: [],
                        },
                      ]);

                      setTimeout(() => setWorkOrderSelectOpen(false), 100);
                    }}
                  >
                    Selecionar Tudo
                  </Button>

                  <Divider style={{ margin: '8px 0' }} />

                  {item}
                </>
              )}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default InvoicingAverageTicketForm;
